module.exports = __webpack_public_path__ + "static/media/GW.0351236f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/GW.svg
// module id = 267
// module chunks = 0